import { render } from "./CurrentView.vue?vue&type=template&id=4811a6c8&scoped=true&ts=true"
import script from "./CurrentView.vue?vue&type=script&lang=ts"
export * from "./CurrentView.vue?vue&type=script&lang=ts"

import "./CurrentView.vue?vue&type=style&index=0&id=4811a6c8&scoped=true&lang=css"

import exportComponent from "/Users/kosugi/Dev/IdeaProjects/v4/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4811a6c8"]])

export default __exports__